// extracted by mini-css-extract-plugin
export default {"contributorUsername":"fmpGozbo","commits":"zziFDxWq","thumbnail":"Tkuvt4Uq"};